"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const BaseInput_1 = __importDefault(require("./BaseInput"));
const FakeStyledInput = (0, styled_components_1.default)(BaseInput_1.default)((0, util_theme_sxc_1.sx2CssThemeFn)({
    '.icon': {
        variant: ['icons.md', 'icons.lg'],
    },
}));
const FakeInput = ({ value, testId, icon, hideLabel = true, label, placeholder, variant, customLabel, className, }) => {
    return (react_1.default.createElement(FakeStyledInput, { "data-id": testId, label: label, hideLabel: hideLabel, value: value, readOnly: true, icon: icon ? { name: icon } : undefined, placeholder: placeholder, variant: variant, className: className, customLabel: customLabel }));
};
exports.default = FakeInput;
//# sourceMappingURL=FakeInput.js.map